export default __webpack_public_path__ + "static/CashflowSupport-4801743996342110f5b8e21ad71070da.mp4";